<template>
	<div class="modal fade" :id="modal.selector" tabindex="-1" role="dialog" aria-hidden="true">
		<div class="modal-dialog modal-sm" role="document">
			<div v-if="data" class="modal-content">
				<div class="modal-header">
					<div class="btn-toolbar pull-right" role="toolbar">
						<div class="btn-group" role="group" aria-label="...">
							<button type="button" class="close" data-dismiss="modal" aria-label="Close">
								<span aria-hidden="true">&times;</span>
							</button>
						</div>
					</div>
					<h4 class="modal-title">
						Factura
						<template v-if="data.provider">
							{{ $platform.setting.number_symbol }}{{ data.prefix }}{{ data.number_invoice_provider }}
						</template>
						<template v-else>
							{{ $platform.setting.number_symbol }}{{ data.prefix }}{{ props.rowD
						</template>
					</h4>
				</div>
				<div class="list-group m-b-0">
					<router-link @click.native="close" :to="'/' + $i18n.locale + '/' + $platform.slug + '/admin/management/invoices/' + data.id" class="list-group-item">
						<i class="fa fa-eye fa-fw" aria-hidden="true"></i>
						Ver
					</router-link>

					<router-link @click.native="close" :to="'/' + $i18n.locale + '/' + $platform.slug + '/admin/management/invoices/'+data.id+'/edit'" class="list-group-item">
						<i class="ti-pencil-alt fa-fw"></i>
						Editar
					</router-link>

					<router-link @click.native="close" :to="'/' + $i18n.locale + '/' + $platform.slug + '/management/invoices/' + data.random" target= '_blank' class="list-group-item">
						<i class="fa fa-file-pdf-o fa-fw" aria-hidden="true"></i>
						Ver PDF
					</router-link>

					<button type="button" @click="downloadPdf(data)" class="list-group-item">
						<i class="fa fa-download fa-fw" aria-hidden="true"></i>
						Descargar PDF
					</button>

					<button type="button" @click="sendEmail(data)" class="list-group-item">
						<i class="fa fa-paper-plane fa-fw" aria-hidden="true"></i>
						Enviar por correo
					</button>

					<button type="button" @click="rectify(data)" class="list-group-item">
						<i class="fa fa-retweet fa-fw" aria-hidden="true"></i>
						Abonar/Rectificar
					</button>
				</div>
				<div class="modal-footer">
					<button type="button" class="btn btn-default" data-dismiss="modal">Cerrar</button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import swal from 'sweetalert2'

	export default {
		props: ['user', 'isAuth'],
		components: {
		},
		data () {
			return {
				modal: {
					selector: 'invoices-actions-' + new Date().getTime(),
				},

				data: null
			}
		},
		methods: {
			open(data) {
				if(data) {
					this.data = data
				} else {
					this.data = null
				}
				var modal = $('#'+this.modal.selector)
				modal.modal('show')
			},
			close() {
				var modal = $('#'+this.modal.selector)
				modal.modal('hide')
			},
			downloadPdf(data) {
				this.close()
				this.$emit('downloadPdf', data)
			},
			sendEmail(data) {
				this.close()
				this.$emit('sendEmail', data)
			},
			rectify(data) {
				this.close()
				this.$emit('rectify', data)
			},
		},
	};
</script>


// WEBPACK FOOTER //
// src/components/management/invoices/views/Actions.vue